import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import Select2Multiple from 'v-select2-multiple-component';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import store from '@/store';

export default {
  name: "EarlyYearList",
  components: {
    MainLayout,
    Loading,
    Select2Multiple,
    AdvancedLaravelVuePaginate
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,

      isFilterOpen: false,
      isLoading: false,
      students: {},

      name: '',
      selectedYear: null,
      selectedGrade: null,

      academicYearArr: [],
      gradeArr: [],

      searchedData: null,
      isSearched: false,
    };
  },

  methods: {
    getEarlyYearStudents(page = 1) {
      this.isLoading = true;
      if (this.isSearched && this.searchedData) {
        this.search(page);
      } else {
        axios.get('early-year/list?page=' + page)
          .then(res => {
            this.students = res.data;
            this.isLoading = false;
          })
          .catch(error => {
            if (error.response && error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
            console.error('Error fetching early year students:', error);
          });
      }
    },

    formatStudentNo(studentNo) {
      return studentNo;
    },

    reset() {
      this.name = '';
      this.selectedYear = null;
      this.selectedGrade = null;
      this.isLoading = true;
      this.searchedData = null;
      this.isSearched = false;
      this.getEarlyYearStudents(1);
    },

    getAcademicYear() {
      axios
        .get("getAcademicYear", {
          params: {
            campus_id: store.state.user.campus_id,
          }
        })
        .then((res) => {
          this.academicYearArr = res.data.academicYearArr ?? [];
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, type) {
      if (type === 'year') {
        this.selectedYear = val;
        this.selectedGrade = null;
        if (val) {
          this.getGradeNameByAcademicYear(val);
        } else {
          this.gradeArr = [];
        }
      }
      else if (type === 'grade') {
        this.selectedGrade = val;
      }
    },

    getGradeNameByAcademicYear(yearId) {
      if (yearId == 0) return;
      axios.get('early-year/getGradeByAcademicYear?id=' + yearId, {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        this.gradeArr = res.data.map(item => ({
          id: item.id,
          text: item.grade_name
        }));
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    search(page = 1) {
      this.isLoading = true;
      this.searchedData = {
        name: this.name,
        academic_year_id: this.selectedYear,
        grade_id: this.selectedGrade,
        section_id: this.selectedSection
      };
      this.isSearched = true;

      const params = {};

      if (this.name && this.name.trim() !== '') {
        params.name = this.name;
      }

      if (this.selectedYear) {
        params.academic_year_id = this.selectedYear;
      }

      if (this.selectedGrade) {
        params.grade_id = this.selectedGrade;
      }

      if (this.selectedSection) {
        params.section_id = this.selectedSection;
      }

      axios.get('early-year/search?page=' + page, {
        params: params
      })
        .then((res) => {
          this.students = res.data;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    showEdit(parentAcademicYearId, studentId) {
      this.$router.push({
        name: 'earlyYearEdit',
        params: { academicYearId: parentAcademicYearId , id: studentId }
      });
    },

    showDetail(parentAcademicYearId, studentId) {
      this.$router.push({
        name: 'earlyYearDetail',
        params: { academicYearId: parentAcademicYearId , id: studentId }
      });
    },

    downloadPDF(student) {
      const studentId = student.id;
      const academicYearId = student.parent_academic_year_id;
      const studentName = student.student_name;

      if (!studentId || !academicYearId) {
        alert('Student or Academic Year information missing');
        return;
      }

      this.isLoading = true;

      axios({
        url: `/early-year/downloadPDF/${studentId}/${academicYearId}`,
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${studentName}'s_report_card.pdf`);
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);

          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error downloading PDF:', error);
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.getEarlyYearStudents(1);
    this.getAcademicYear();
  },
};
